import React from 'react';
import './index.css';
import 'rc-banner-anim/assets/index.css';
import clsx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { ImageLoader, Loading, More } from 'components';
import { useHistory } from 'react-router-dom';
import { useProductList } from 'hooks';
import { useAppContext } from 'context';

const Product = () => {
  const history = useHistory();
  const { dispatch } = useAppContext();

  // 获取产品列表数据
  const { data, loading } = useProductList();
  const clist = data?.clist?.concat({
    name: '最新产品',
    cid: 'new',
  });

  const dataClist = clist?.map((v) => {
    const firstItem = data?.dlist?.find((item) => item.cid === v.cid);
    const secoundItem = data?.dlist?.filter((item) => item.isnew === '1')[1];
    const item = v?.cid === 'new' ? secoundItem : firstItem;
    const imgUrl = 'https://api.zjzyfwq.com' + item?.imgs[0]?.url.slice(4);
    return { ...v, imgUrl };
  });

  const onClick = (type) => {
    history.push('/productCenter');
    dispatch({
      type: 'SET_PRODUCT_TYPE',
      payload: type,
    });
  };

  const breakpoints = {
    // 小屏幕（手机）
    640: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    // 中等屏幕（平板）
    768: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    // 大屏幕（桌面）
    880: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    1210: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    1500: {
      slidesPerView: 3,
      spaceBetween: 5,
    },
    1800: {
      slidesPerView: 4,
      spaceBetween: 5,
    },
  };
  return (
    <div className={clsx('product')}>
      <div className={clsx('product-title')}>最新产品</div>
      <div className={clsx('product-desc')}>
        我们将坚持以科技为先导，市场为龙头，用户满意为宗旨的经营方针，不断发展创新
      </div>
      {!loading ? (
        <div className={clsx('product-list')}>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            autoplay={true}
            loop={false}
            // 关闭底部点设置
            pagination={false}
            breakpoints={breakpoints}
            className={clsx('product-swiper')}
          >
            {dataClist?.map((v, index) => (
              <SwiperSlide key={index}>
                <div className={clsx('product-item')}>
                  <div
                    className={clsx('product-item-img')}
                    onClick={() => onClick(v.cid)}
                  >
                    <ImageLoader
                      src={v?.imgUrl}
                      alt=''
                      width={'100%'}
                      height={'100%'}
                    />
                  </div>
                  <div
                    className={clsx('product-item__text')}
                    onClick={() => onClick(v.cid)}
                  >
                    {v?.name}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <Loading />
      )}
      {/* 更多按钮 */}
      <More path='/productCenter' style={{ margin: '24px 0' }} clist={clist} />
    </div>
  );
};

export default Product;
